/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
/* eslint-disable no-restricted-syntax */
import { Box, TableCell, TableRow } from "@mui/material";
import { Formik } from "formik";
import { pickBy } from "lodash";
import queryString from "query-string";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import Pagination from "../../../../components/common/new/Pagination/Pagination";
import * as Sentry from "@sentry/react";
import Button from "../../../../components/common/Button";
// import EyeIcon from "../../../../assets/svg/Eye";
import CustomTable from "../../../../components/common/new/Table/Table";
import Typography from "../../../../components/common/new/Typography/Typography";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../../contants";
import EditIcon from "../../../../assets/svg/Edit";
import Delete from "../../../../assets/svg/Delete";
import {
  SPLIT_API_MAPPER,
  STRUCTURE_LEVEL_MAPPER,
} from "../../../../contants/appointment";
import {
  // ORGANIZATION_STRUCTURE_FIELDS,
  SPLIT_SEARCH_FIELDS,
} from "../../../../contants/formFields";
import { LIST_OF_DISTRICT_SPLIT_COL } from "../../../../contants/table/appointment";
import useQueryParams from "../../../../hooks/useQueryParams";
import {
  RESET_SPLIT_SEARCH_RESULT,
  SET_SPLIT_SEARCH_RESULT,
} from "../../../../redux/actionTypes/dashboard";
import {
  selectParentStructure,
  selectSplitLevel,
  selectSplitSearchResult,
} from "../../../../redux/selectors/appointment";
import { selectOrganisationStructure } from "../../../../redux/selectors/meta";
import {
  // selectAllSIUsers,
  selectOSKeysByUserRole,
  selectUserProfile,
} from "../../../../redux/selectors/user";
import tableStyle from "../../../../theme/styles/table";
import { ROUTES } from "../../../../utils/constants";
import {
  convertToId,
  convertToName,
  isEmptyObj,
  toLowerCase,
} from "../../../../utils/helper";
import OrganisationSearch from "../components/OrganisationSearch";
import Styles from "./SplitApply.styles";
import EditStructureModal from "../BulkTransfer/EditStructureModal";
import DeleteStructureModal from "../BulkTransfer/DeleteStructureModal";

// const SPLIT_LEVEL_OPTIONS = [
//   {
//     key: "DISTRICT",
//     value: "DISTRICT",
//   },
// ];

const getParentStructureKeyId = (formValues) => {
  let selectedLevel = "";

  for (const key of Object.values(SPLIT_SEARCH_FIELDS)) {
    if (!formValues[key]) {
      break;
    }
    selectedLevel = key;
  }
  return selectedLevel;
};

const getColumns = (columns, structureName) =>
  structureName
    ? columns.with(1, { displayName: structureName, key: "structure" })
    : columns;

const formValidation = (values) => {
  if (!values) return "Please enter valid inputs";
  return null;
};

function SplitApply() {
  // const paginationInfo = useSelector(selectPaginationInfo);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedStructureId, setSelectedStructureId] = useState(null);
  const searchResult = useSelector(selectSplitSearchResult);
  const splitStrutureLevel = useSelector(selectSplitLevel);
  const parentStruture = useSelector(selectParentStructure);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const userData = useSelector(selectUserProfile);
  const organisationStructure = useSelector(selectOrganisationStructure);
  // const { isHelpDesk } = useSelector(selectAllSIUsers);
  const alert = useContext(ToastAlertContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();
  const formRef = useRef(null);

  const toggleEditModal = () => setEditModalOpen((prev) => !prev);
  const toggleDeleteModal = () => setDeleteModalOpen((prev) => !prev);

  const onEditClick = (id) => {
    setSelectedStructureId(id);
    toggleEditModal();
  };

  const onDeleteClick = (id) => {
    setSelectedStructureId(id);
    toggleDeleteModal();
  };

  const preselectOSKeys = () => {
    if (disabledOSKeys?.length && !isEmptyObj(userData)) {
      return disabledOSKeys.reduce(
        (acc, key) => ({
          ...acc,
          [key]: userData[key] || "",
        }),
        {}
      );
    }
    return {};
  };

  const initializeFormValues = () => {
    const queryValues = getQueryObject();
    const formValues = isEmptyObj(queryValues)
      ? preselectOSKeys()
      : queryValues;

    return {
      [SPLIT_SEARCH_FIELDS.AREA]:
        Number(formValues[SPLIT_SEARCH_FIELDS.AREA]) || "",
      [SPLIT_SEARCH_FIELDS.ZONE]:
        Number(formValues[SPLIT_SEARCH_FIELDS.ZONE]) || "",
      [SPLIT_SEARCH_FIELDS.REGION]:
        Number(formValues[SPLIT_SEARCH_FIELDS.REGION]) || "",
      [SPLIT_SEARCH_FIELDS.CHAPTER]:
        Number(formValues[SPLIT_SEARCH_FIELDS.CHAPTER]) || "",
      [SPLIT_SEARCH_FIELDS.DISTRICT]:
        Number(formValues[SPLIT_SEARCH_FIELDS.DISTRICT]) || "",
    };
  };

  const [parentId, parentKeyNameId] = useMemo(() => {
    const initalValues = formRef?.current
      ? formRef?.current.values
      : initializeFormValues();

    const parentKeyId = getParentStructureKeyId(initalValues);
    return [
      (parentKeyId && Number(initalValues[parentKeyId])) || 0,
      (parentKeyId && STRUCTURE_LEVEL_MAPPER[convertToName(parentKeyId)]) ||
        "AREA",
    ];
  }, [parentStruture, initializeFormValues, formRef?.current]);

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`/${ROUTES.NEW_STRUCTURE_APPLY.path}?${query}`);
    } else {
      navigate(`/${ROUTES.NEW_STRUCTURE_APPLY.path}`);
    }
  };

  // const onView = (structureId) => {
  //   navigate(`/${ROUTES.NEW_STRUCTURE_CHART.path}/${structureId}`);
  // };

  const getRows = ({ data, parent }) =>
    data.map((item) => (
      <TableRow style={tableStyle.tableRow}>
        <TableCell
          style={{ ...Styles.cell, color: "#043D90", fontWeight: "600" }}
        >
          {item.structureId}
        </TableCell>
        <TableCell style={Styles.cell}>{item.name || "NA"}</TableCell>
        <TableCell style={Styles.cell}>{parent || "NA"}</TableCell>
        {/* <TableCell style={Styles.cell}>Chapter</TableCell> */}
        <TableCell>
          <EditIcon
            style={Styles.icon}
            onClick={() => onEditClick(item.structureId)}
          />
          <Delete
            style={Styles.icon}
            onClick={() => onDeleteClick(item.structureId)}
          />
          {/* <EyeIcon
            style={Styles.icon}
            onClick={() => onView(item.structureId)}
          /> */}
        </TableCell>
      </TableRow>
    ));

  const setDataToRedux = ({ data, splitLevel, parentLevel, selectedOS }) =>
    dispatch({
      type: SET_SPLIT_SEARCH_RESULT,
      payload: {
        data,
        splitLevel,
        selectedOS,
        parentStructure: parentLevel,
        // paginationInfo: {
        //   currentPage: data.number,
        //   totalPages: data.totalPages,
        //   totalElements: data.totalElements,
        //   pageSize: data.size,
        // },
      },
    });

  const getSplitLevel = (formValues) => {
    let selectedLevel = "DEFAULT";
    let selectedOS = {};

    for (const key of Object.values(SPLIT_SEARCH_FIELDS)) {
      if (!formValues[key]) {
        break;
      }
      selectedOS = { ...selectedOS, [key]: Number(formValues[key]) };
      selectedLevel = convertToName(key);
    }
    return {
      parentLevel: selectedLevel,
      splitLevel: STRUCTURE_LEVEL_MAPPER[selectedLevel],
      selectedOS,
    };
  };

  const fetchSearchResult = async (
    values
    // params = { page: 0, pageSize: Constants.DEFAULT_PAGE_SIZE }
  ) => {
    try {
      // const { data } = await Member.search(payload, params);
      const { parentLevel, splitLevel, selectedOS } = getSplitLevel(values);
      const chiefKey = convertToId(parentLevel);

      const api = SPLIT_API_MAPPER[parentLevel];

      const payload = {
        data: { [chiefKey]: Number(values[chiefKey]) },
      };
      const { data } = await api(parentLevel === "DEFAULT" ? {} : payload);

      setDataToRedux({ data, splitLevel, parentLevel, selectedOS });
    } catch (error) {
      alert.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  // const onPaginationClick = (clickedNumber) => {
  //   const queryObject = getQueryObject();
  //   const queryParams = queryString.stringify({
  //     ...queryObject,
  //     page: clickedNumber,
  //   });
  //   updateSearchParam(queryParams);
  // };

  // const onPageSizeClick = (operator) => {
  //   const queryObject = getQueryObject();
  //   const queryParams = queryString.stringify({
  //     ...queryObject,
  //     page: 0,
  //     pageSize: queryObject.pageSize
  //       ? performOperation(
  //           queryObject.pageSize,
  //           Constants.DEFAULT_PAGE_SIZE,
  //           operator
  //         )
  //       : 2 * Constants.DEFAULT_PAGE_SIZE,
  //   });
  //   updateSearchParam(queryParams);
  // };

  const onSearch = (values) => {
    try {
      const error = formValidation(values);
      if (error) throw new Error(error);

      const query = queryString.stringify(pickBy(values, Boolean));
      // console.log("QUERY", query);
      updateSearchParam(query);
    } catch (error) {
      alert.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    const initialState = initializeFormValues();
    const [query, params] = getQueryParams(initialState);
    // console.log("LOGGER", query);
    fetchSearchResult(query, params);
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    // reset search result state
    return () => dispatch({ type: RESET_SPLIT_SEARCH_RESULT });
  }, []);

  const onRefresh = () => {
    const initialState = initializeFormValues();
    const [query, params] = getQueryParams(initialState);
    fetchSearchResult(query, params);
  };

  // const hiddenOsFields = !isHelpDesk
  //   ? [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]
  //   : [];

  const parentStrutureName = useMemo(() => {
    if (formRef.current) {
      const parentKeyName = convertToId(parentStruture);
      const parentKeyId = Number(formRef.current.values[parentKeyName]);

      const osKey = `${toLowerCase(parentStruture)}s`;
      const list = organisationStructure[osKey];

      return list?.length
        ? list.find((str) => str.structureId === parentKeyId)?.name
        : "National";
    }
    return "National";
  }, [organisationStructure, formRef.current?.values, parentStruture]);

  const getParentStructureLevel = () => {
    // Define the mapping of structure levels and their parents.
    const structureLevelParents = {
      BLOCK: "District",
      DISTRICT: "Chapter",
      CHAPTER: "Region",
      REGION: "Zone",
      ZONE: "Area",
      AREA: "National",
    };

    // Return the parent structure level based on the input splitStructureLevel.
    return structureLevelParents[splitStrutureLevel];
  };

  const parentStructureLevel = getParentStructureLevel(splitStrutureLevel);
  // console.log("Parent Structure Level: ", parentStrutureName, searchResult);

  const onAddClick = () => {
    dispatch({
      type: SET_SPLIT_SEARCH_RESULT,
      payload: { parentStrutureName, parentStructureLevel },
    });
    navigate(
      `/${ROUTES.NEW_STRUCTURE_APPLY_CREATE.path}/${parentKeyNameId}/${parentId}`
    );
  };

  return (
    <Box>
      <Box style={Styles.addNew}>
        <Button
          // to={`/${ROUTES.NEW_STRUCTURE_APPLY_CREATE.path}/${parentKeyNameId}/${parentId}`}
          style={{
            ...Styles.addNewLink,
            ...(!parentId ? Styles.disabled : {}),
          }}
          onClick={() => onAddClick()}
          label="Add New +"
        />
      </Box>

      <Box style={Styles.filters}>
        <Formik
          innerRef={formRef}
          initialValues={initializeFormValues()}
          onSubmit={onSearch}
        >
          {({
            values,
            errors,
            handleChange,
            setFieldValue,
            handleSubmit,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit}>
              {/* <Dropdown
                name="hierarchy"
                value={values.hierarchy}
                options={SPLIT_LEVEL_OPTIONS}
                label="Select level to split"
                onChange={handleChange}
                style={{
                  width: "48.8%",
                  marginBottom: "1rem",
                }}
              /> */}
              <OrganisationSearch
                values={values}
                errors={errors}
                handleChange={handleChange}
                setFieldValue={setFieldValue}
                disabledOSKeys={disabledOSKeys}
                // hiddenFields={hiddenOsFields}
              />
              <Button type="submit" variant="contained" label="SEARCH" />
            </form>
          )}
        </Formik>
      </Box>
      {searchResult?.length > 0 && parentStrutureName && (
        <>
          <Typography component="p" color="#8C8C8C" weight={500} my={4}>
            List of {toLowerCase(splitStrutureLevel)}s
          </Typography>
          <CustomTable
            columnCellStyle={{ textAlign: "left" }}
            scrollable
            columns={getColumns(LIST_OF_DISTRICT_SPLIT_COL, splitStrutureLevel)}
            rows={getRows({
              data: searchResult,
              parent: parentStrutureName,
            })} // TODO: Extend for other SI
            tableBodyTheme="#F6F6F6"
            tableHeadCellStyle={{
              ...Styles.tableHeadCells,
              textAlign: "left",
            }}
          />
          {/* <Box style={Styles.pagination}>
            <Pagination
              totalPages={paginationInfo.totalPages}
              totalResults={paginationInfo.totalElements}
              currentPage={paginationInfo.currentPage}
              pageSize={paginationInfo.pageSize}
              onChange={onPaginationClick}
              onPageSizeClick={onPageSizeClick}
            />
          </Box> */}
        </>
      )}
      <EditStructureModal
        open={editModalOpen}
        hierarchy={parentKeyNameId}
        structureId={selectedStructureId}
        onClose={toggleEditModal}
        refreshList={onRefresh}
      />
      <DeleteStructureModal
        open={deleteModalOpen}
        structureId={selectedStructureId}
        onClose={toggleDeleteModal}
        refreshList={onRefresh}
      />
    </Box>
  );
}

export default SplitApply;
